import xss from 'xss';
import { convertShortcodeHyphen } from './convertShortcodeHyphen';
import { convertShortcodeDivider } from './convertShortcodeDivider';
import { convertShortcodeBlockQuote } from './convertShortcodeBlockQuote';
import { convertHtmlToReact } from './convertHtmlToReact';
import { xssOptions } from './allowedTagsAndAttributes';

export const processBodyText = (bodyText: string) => {
  const sanitizedBodyText = xss(bodyText, {
    ...xssOptions,
    onTagAttr(tag, name, value) {
      const allowedProtocols = ['sms:'];

      if (tag === 'a' && name === 'href' && allowedProtocols.some((p) => value.startsWith(p))) {
        return `href="${value}"`;
      }

      return undefined;
    },
  });
  const withHyphens = convertShortcodeHyphen(sanitizedBodyText);
  const withDivider = convertShortcodeDivider(withHyphens);
  const withBlockQuote = convertShortcodeBlockQuote(withDivider);
  const processedBodyText = convertHtmlToReact(withBlockQuote);
  return processedBodyText;
};
